import { useNavigate } from '@tanstack/react-router';

export const GeneralError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="mx-auto my-10">
        <button onClick={async () => navigate({ to: '/', reloadDocument: true })} name="general-error-btn">
          Back
        </button>
      </div>
    </>
  );
};
